import { Relations, UserId } from "@inrev/common";
import type { ActionItemByIdMap } from "@portal/api/action-item";
import { Modal } from "@portal/components/layout/Modal";
import {
	useActionItemsSelection,
	useActionItemsSelectionDispatch,
} from "@portal/providers/ActionItemsSelectionProvider";
import { FC, useState } from "react";
import { AdminActionItemsHeader } from "./components/AdminActionItemsHeader";
import { AdminActionItemsLayout } from "./layouts/AdminActionItemsLayout";
import { AdminActionItemCreateSection } from "./sections/AdminActionItemCreateSection";
import { AdminActionItemEdit } from "./sections/AdminActionItemEdit";
import { AdminActionItemListSection } from "./sections/AdminActionItemListSection";

export type AdminActionItemViewProps = {
	actionItemMap: ActionItemByIdMap;
	relation: Relations.ActionItems;
	defaultUnderwriterId: UserId;
};

export const AdminActionItemView: FC<AdminActionItemViewProps> = ({
	actionItemMap,
	relation,
	defaultUnderwriterId,
}) => {
	const [openCreateActionItem, setOpenCreateActionItem] = useState(false);
	const { editActionItem } = useActionItemsSelection();
	const { setEditActionItem } = useActionItemsSelectionDispatch();

	const content = (
		<>
			<div data-testid="admin-action-item-create-section" className="sticky top-0 z-10 bg-white">
				<AdminActionItemCreateSection
					isOpen={openCreateActionItem}
					relation={relation}
					defaultUnderwriterId={defaultUnderwriterId}
					onClose={() => setOpenCreateActionItem(false)}
				/>
			</div>
			<div data-testid="admin-action-item-list-section" className="flex flex-col overflow-y-hidden">
				<AdminActionItemListSection actionItems={actionItemMap} />
			</div>
		</>
	);

	return (
		<>
			<AdminActionItemsLayout
				header={<AdminActionItemsHeader createActionItem={() => setOpenCreateActionItem(true)} />}
				content={content}
			/>
			{
				// Only show edit modal if the action item exists in the list
				editActionItem && actionItemMap[editActionItem.id] && (
					<Modal onClickOutside={() => setEditActionItem(undefined)}>
						<div
							id="admin-action-item-edit-modal"
							data-testid="admin-action-item-edit-modal"
							className="bg-white rounded-lg min-w-[100vw] sm:min-w-[350px] "
						>
							<AdminActionItemEdit
								actionItem={editActionItem}
								defaultUnderwriterId={defaultUnderwriterId}
							/>
						</div>
					</Modal>
				)
			}
		</>
	);
};
